// Select all elements with the class 'footer__item__title__wraper'
const items = document.querySelectorAll(".footer__item__title__wraper");

// Loop through each item
items.forEach((item) => {
  // Add a click event listener to each item
  item.addEventListener("click", function () {
    // Check if the clicked item already has the 'active' class
    if (this.classList.contains("active")) {
      // If it already has 'active', remove it
      this.classList.remove("active");
    } else {
      // Otherwise, remove 'active' class from all items
      items.forEach((i) => i.classList.remove("active"));

      // Add 'active' class to the clicked item
      this.classList.add("active");
    }
  });
});

$(document).ready(function () {

  let listIcon = $('.main_tabs_icon .icon_list_svg').attr("data-label");
  $('.main_tabs_icon .icon_list_svg[data-label="1"]').addClass("button-color");

  $(".main_list_icon .title_icon_content").each(function () {
    var iconbtn = $(this).attr("logo-id");
    if (listIcon == iconbtn) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  $(document).on("click", ".main_tabs_icon .icon_list_svg", function () {
    $(this).addClass("button-color").siblings().removeClass("button-color");
    let listIcon = $(this).attr("data-label");
    $(".main_list_icon .title_icon_content").each(function () {
      var iconbtn = $(this).attr("logo-id");
      if (listIcon == iconbtn) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });



  $('.button-group__wrapper a.button.button--primary[data-id="e19cc4cd-ab70-47dd-9575-cb14beb1fdb4-1"]').addClass("button-color");
  var btn = $('.button-group__wrapper a.button.button--primary').data("id");
  $(".inner.custom_slideshow .stories-nav").each(function () {
    var iconbtn = $(this).data("tab");
    if (btn == iconbtn) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
  $(document).on("click", "a.button.button--primary", function (e) {
    $(this).addClass("button-color").siblings().removeClass("button-color");
    e.preventDefault();
    var btn = $(this).data("id");
    $(".inner.custom_slideshow .stories-nav").each(function () {
      var iconbtn = $(this).data("tab");
      if (btn == iconbtn) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});
// ------------------------- accordions faqs ---------------------------------
const accordionHeaders = document.querySelectorAll('[hb-accordion-panel-main-header]');
accordionHeaders.forEach((header) => {
  header.addEventListener('click', function () {
    const accordionParent = header.parentElement;
    const accordionContent = accordionParent.querySelector('[hb-accordion-panel-main-content]');
    const isActive = accordionParent.classList.contains('active');
    document.querySelectorAll('[js-accordion-panel-main]').forEach((panel) => {
      panel.classList.remove('active');
      const panelContent = panel.querySelector('[hb-accordion-panel-main-content]');
      if (panelContent) {
        panelContent.style.height = '0';
      }
    });
    if (!isActive) {
      accordionParent.classList.add('active');
      if (accordionContent) {
        accordionContent.style.height = accordionContent.scrollHeight + 'px';
      }
    }
  });
});

function initVariantsOption() {
  const productCards = document.querySelectorAll('[js-product-card]');
  if (productCards) {
    productCards.forEach(function (card) {
      const variantPills = card.querySelectorAll('[js-variant-pills]');
      const primaryImage = card.querySelector('[js-product-image]');
      const secondaryImage = card.querySelector('[js-secondary-image]');

      function handleResize() {
        if (document.documentElement.clientWidth > 767) {
          const variants_json = JSON.parse(card.querySelector("[js-variants-json]").textContent);
          const product_options = card.querySelector("[js-product-options]");
          const checked_inputs = product_options.querySelectorAll('input[type="radio"]:checked');
          const formatted_values = Array.from(checked_inputs)
            .map(input => `${input.value}`)
            .join(' / ');

          const varaints_family = variants_json.filter(variant =>
            variant.option1 === checked_inputs[0].value ||
            variant.option2 === checked_inputs[0].value ||
            variant.option3 === checked_inputs[0].value
          );

          const current_variant = variants_json.find(variant => variant.title === formatted_values) || varaints_family.at(0);

          if (current_variant) {
            setInitialAvailability(card, current_variant, variants_json);
          }
        }
      }

      window.addEventListener('resize', handleResize);
      handleResize();

      variantPills.forEach(function (variantPill) {
        variantPill.addEventListener('change', function () {
          const currentProductHandle = this.getAttribute('data-product-handle');
          const variantsJson = JSON.parse(card.querySelector("[js-variants-json]").textContent);
          const productLink = card.querySelector('[js-product-url]');
          const productPriceEl = card.querySelector("[js-product-price]");

          const productOptions = card.querySelector("[js-product-options]");
          const checkedInputs = productOptions.querySelectorAll('input[type="radio"]:checked');
          const formattedValues = Array.from(checkedInputs)
            .map((input, index) => `${input.value}`)
            .join(' / ');


          const varaintsFamily = variantsJson.filter(variant => variant.option1 === this.value || variant.option2 === this.value || variant.option3 === this.value);
          const current_variant = variantsJson.find(variant => variant.title === formattedValues) || varaintsFamily.at(0);

          if (!current_variant) return;

          let priceHTML;
          if (current_variant.compare_at_price > current_variant.price) {
            priceHTML = `
              <span class="price price--compare" js-compare-price>${theme.Currency.formatMoney(current_variant.compare_at_price)}</span>
              <span class="price" js-price>${theme.Currency.formatMoney(current_variant.price)}</span>
              <span class="label label--highlight">Du sparst ${theme.Currency.formatMoney(current_variant.compare_at_price - current_variant.price)}</span>
            `;
          } else {
            priceHTML = `
              <span class="price" js-price>${theme.Currency.formatMoney(current_variant.price)}</span>
            `;
          }

          productPriceEl.innerHTML = priceHTML;

          const newProductUrl = `/products/${currentProductHandle}?variant=${current_variant.id}`;
          productLink.href = newProductUrl;

          if (this.classList.contains("is-swatch-color")) {
            const primaryImageUrl = this.getAttribute('data-primary-image-src');
            const secondaryImageUrl = this.getAttribute('data-secondary-image-src');

            if (primaryImageUrl) {
              primaryImage.setAttribute('srcset', primaryImageUrl);
              primaryImage.setAttribute('src', primaryImageUrl);
            }

            if (secondaryImageUrl) {
              secondaryImage?.setAttribute('srcset', secondaryImageUrl);
              secondaryImage?.setAttribute('src', secondaryImageUrl);
            }
          };

          if (document.documentElement.clientWidth > 767) {
            setInitialAvailability(card, current_variant, variantsJson);
          }
        });
      });
    });

    function setInitialAvailability(card, current_variant, variantsJson) {
      card.querySelectorAll('[js-option-block]').forEach(group => {
        disableVariantGroup(group);
      });

      const currentlySelectedValues = current_variant.options.map((value, index) => { return { value, index: `option${index + 1}` } })
      const initialOptions = createAvailableOptionsTree(variantsJson, currentlySelectedValues, current_variant);

      for (var [option, values] of Object.entries(initialOptions)) {
        manageOptionState(card, option, values);
      }
    }

    function disableVariantGroup(group) {
      group.querySelectorAll('[js-variant-block]').forEach(block => {
        block.setAttribute("hidden", "")
      });
    }

    function createAvailableOptionsTree(variants, currentlySelectedValues) {
      return variants.reduce((options, variant) => {

        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = { value: variant[index], soldOut: true }
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

          switch (index) {
            case 'option1':
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              break;
            case 'option2':
              if (currentOption1 && variant['option1'] === currentOption1.value) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
            case 'option3':
              if (
                currentOption1 && variant['option1'] === currentOption1.value
                && currentOption2 && variant['option2'] === currentOption2.value
              ) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
          }
        })

        return options;
      }, { option1: [], option2: [], option3: [] })
    }

    function manageOptionState(card, option, values) {
      var group = card.querySelector('[js-option-block][data-index="' + option + '"]');

      values.forEach(obj => {
        enableVariantOption(group, obj);
      });
    }

    function enableVariantOption(group, obj) {
      var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
      var buttonGroup = group.querySelector('[js-variant-block][data-value="' + value + '"]');

      buttonGroup.removeAttribute("hidden");

      if (obj.soldOut) {
        buttonGroup.setAttribute("hidden", "");
      }
    }
  }
}

initVariantsOption();
document.addEventListener('variant-options:init', initVariantsOption);